module.exports = __webpack_public_path__ + "img/Event_Icon_Merch_White.4dbfe787.png";